import { render } from "./PostsView.vue?vue&type=template&id=04e582e2&scoped=true"
import script from "./PostsView.vue?vue&type=script&lang=js"
export * from "./PostsView.vue?vue&type=script&lang=js"

import "./PostsView.vue?vue&type=style&index=0&id=04e582e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e582e2"]])

export default __exports__